module.exports = __webpack_public_path__ + "img/bb_g3_mouth-05.3af70021.svg";